import axios from 'axios';

export async function sendData(payload) {
  const res = await axios.get(process.env.REACT_APP_URL2+'/api/window-sticker-share?dealership='+payload.subdomain+'&vin='+payload.vin+'&email='+payload.email+'&phone='+payload.phone);
  return res.data.response;
}
